Updates an existing unposted position profile.
